import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/physical-security/dome-turret/g6-pro-360.png";
import type { Product } from "../../types";
import { physicalSecurityDomeTurret } from "../product-list-groups/physicalSecurityDomeTurret";
import { deployment, outdoorReady } from "../properties";

export const g6Pro360: Product = {
  id: "g6Pro360",
  productTitle: "G6 Pro 360",
  isNew: true,
  techspecsPath: [SiteId.TechSpecs, `/unifi/cameras-nvrs/uvc-g6-pro-360`],
  storePathParts: {
    productSlug: "uvc-g6-pro-360",
    category: "cameras-dome-turret",
  },
  description: "g6Pro360.description",
  image: { src: image, width: 200, height: 140 },
  productListGroup: physicalSecurityDomeTurret,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: 'Ø147 x 65.5\n(Ø5.8 x 2.6")',
      },
    },
    {
      propertyId: "cameraResolution",
      value: { type: "string", value: "12MP" },
    },
    {
      propertyId: "imageSensor",
      value: { type: "string", value: '1/1.6" 12MP' },
    },
    {
      propertyId: "fieldOfView",
      value: {
        type: "translation",
        value: "g6Pro360.fieldOfView",
      },
    },
    {
      propertyId: "nightVision",
      value: {
        type: "translation",
        value: "g6Pro360.nightVision",
      },
    },
    {
      propertyId: "opticalZoom",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "smartDetections",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "enhancedDetections",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "aiRecognition",
      value: {
        type: "boolean",
        value: true,
      },
    },
    {
      propertyId: "faceRecognition",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "licensePlateRecognition",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "cameraAudio",
      value: {
        type: "translation",
        value: "commons.cameraAudio.twoWayAudio",
      },
    },
    {
      propertyId: outdoorReady.id,
      value: { type: "string", value: "IP66" },
    },
    {
      propertyId: "tamperResistance",
      value: { type: "string", value: "IK08" },
    },
    {
      propertyId: deployment.id,
      value: { type: "string", value: "PoE+" },
    },
  ],
};
